import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { UserSelectionComponent } from './components/user-selection/user-selection.component';

export const routes: Routes = [
  {
    path: '',
    component: UserSelectionComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'login-failed',
    loadComponent: () => import('./components/login-failed/login-failed.component').then(m => m.LoginFailedComponent)
  }
];
